export default __webpack_public_path__ + "static/media/Mike Truk.a58461a4.jpg";